// API utils
export function handleApiError(error, context = 'operation') {
  console.error(`Error during ${context}:`, error);
  // You could extend this to show a toast notification or other UI feedback
}

export function showAlert(message) {
  return alert(message);
}

export function showConfirmDialog(message) {
  return confirm(message);
}

export function copyToClipboard(text) {
  return navigator.clipboard.writeText(text);
}

// List utils
export function sortByLastModified(items) {
  return items.sort((a, b) => new Date(b.last_modified) - new Date(a.last_modified));
}

export function isInteractiveElement(event) {
  return event.target.closest('button, a, .actions, [role="button"], .editable-field, .inline-edit, input');
}
// Form utils
export function validatePassword(password) {
  if (password.length < 8) {
    return { success: false, error: 'Password must be at least 8 characters long' };
  }

  const isLongPassword = password.length > 24;
  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasDigit = /\d/.test(password);
  const hasSpecial = /[^a-zA-Z0-9]/.test(password);
  const isComplexPassword = hasLower && hasUpper && hasDigit && hasSpecial;

  if (!isLongPassword && !isComplexPassword) {
    return {
      success: false,
      error: 'Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character'
    };
  }

  return { success: true };
}

// Data formatting
export const formatDuration = (duration) => {
  if (!duration) return null;
  const minutes = Math.floor(duration / 60);
  const seconds = Math.floor(duration % 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const formatEstimatedDuration = (duration) => {
  if (duration <= 0) return null;
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor(duration / 60);
  
  if (hours > 0) {
    return `${hours}hr ${minutes}min`;
  } else if (minutes > 0) {
    return `${minutes}min`;
  } else {
    return `a few seconds`;
  }
};

export function formatTimecode(seconds, fps) {
  if (seconds === null || seconds === undefined) return '--:--:--.---';
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  let fff = Math.round((seconds % 1) * 1000);
  let fffPad = 3;
  // For compatibility, if a fps is provided, fff represents the frame count 
  // Otherwise it represents the milliseconds
  if (fps > 0) {
    fff = Math.round(fff / fps);
    fffPad = fps < 100 ? 2 : 3;
  }
  
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}.${fff.toString().padStart(fffPad, '0')}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return 'N/A';
  const utc = new Date(dateStr);
  const offset = utc.getTimezoneOffset()
  const date = new Date(utc.getTime() - offset * 60000)
  return date.toLocaleDateString();
}

export function formatDatetime(dateStr) {
  if (!dateStr) return 'N/A';
  const utc = new Date(dateStr);
  const offset = utc.getTimezoneOffset()
  const date = new Date(utc.getTime() - offset * 60000)
  return date.toLocaleString();
}

export function formatStatus(status) {
  if (!status) return 'N/A';
  return status.replace(/([A-Z])/g, ' $1').trim();
}

export function formatFileSize(bytes) {
  const units = ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let unitIndex = 0;
  
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }
  
  const sizeString = size.toFixed(1);
  return `${sizeString.endsWith('.0') ? parseInt(sizeString) : sizeString} ${units[unitIndex]}`;
}

export function formatBitrate(bitrate) {
  if (!bitrate) return '';
  const mbps = bitrate / 1000000;
  return `${mbps.toFixed(1)} Mbps`;
}

// Data parsing
export function extractHeight(resolution) {
  if (!resolution) return -1;
  const match = resolution.match(/\d+x(\d+)/);
  return match ? parseInt(match[1]) : -1;
}